import {Directive, ElementRef, HostListener} from "@angular/core";

@Directive({
  selector: '[appScroll]',
})
export class ScrollDirective {
  constructor(private el: ElementRef) {
  }

  @HostListener('click') moveTop() {
    if (window.innerWidth <= 767) {
      (<HTMLElement>this.el.nativeElement).scrollIntoView(true);
    }
  }
}
